import { useContext, createContext, useState } from "react"
import { useNavigate } from "react-router-dom"
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from "constants/appState.js"

// context
import useAppState from "./useAppState"
import useRefreshToken from "utilities/useRefreshToken"

// apis
import { deleteCookie } from "api/apiUtils"
import { postLogout } from "../../api/hooks/auth/useAuthApis"
import useErrors from "../../api/utils/useErrors"

// utils
import getUrl from "api/apiMap"
import APP_STATE from "constants/appState.js"

export const AuthProvider = ({ children }) => {
  const { setAppState, appStateRef } = useAppState()
  const [auth, setAuth] = useState({})
  const navigate = useNavigate()
  const { errorHandler } = useErrors()
  const { setTokens, isAccessTokenExpired, isRefreshTokenExpired, setNextUrlLocalStorage } = useRefreshToken()

  const isUserAuthenticated = () => {
    if (isAccessTokenExpired() === false && isRefreshTokenExpired() === false) {
      setAppState(APP_STATE.authenticated)
      return true
    }

    return false
  }

  const logout = async () => {
    setAppState(APP_STATE.loading)
    appStateRef.current = APP_STATE.loading
    try {
      await postLogout()
      setNextUrlLocalStorage()
      appStateRef.current = APP_STATE.unauthenticated
      setAppState(APP_STATE.unauthenticated)
      setAuth({
        refresh: null,
        access: null,
      })
      setTokens({
        refresh: null,
        access: null,
      })
      deleteCookie(ACCESS_TOKEN_KEY)
      deleteCookie(REFRESH_TOKEN_KEY)
      navigate("/login")
    } catch (error) {
      appStateRef.current = APP_STATE.authenticated
      setAppState(APP_STATE.authenticated)
      errorHandler({ error })
    }
  }

  return (
    <AuthContext.Provider
      value={{
        auth,
        setAuth,
        logout,
        isUserAuthenticated,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

const AuthContext = createContext({})

const useAuth = () => {
  return useContext(AuthContext)
}

export default useAuth
